import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import EmptyLayout from "@/layout/empty/EmptyLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Login from "@/pages/Login.vue";
import UpdatePassword from "@/pages/UpdatePassword.vue";

import UserProfileTwitch from "@/pages/UserProfileTwitch.vue";
import Billing from "../pages/Pricing.vue";
import BillingSuccess from "@/pages/PricingSuccess.vue";
import MakeClips from "@/pages/MakeClips.vue";
import Agenda from "@/pages/Agenda.vue";
import Analysis from "@/pages/Analysis.vue";
import TwitchPostadmin from "@/pages/TwitchPostadmin.vue";
import UsersList from "@/pages/UsersList.vue";
import Results from "@/pages/Results.vue";
import PublicResults from "@/pages/PublicResults.vue";
import CliprPurchases from "@/pages/clipr_purchases.vue";
import SubscriptionPlansAdmin from "@/pages/SubscriptionPlansAdmin.vue";
import AffiliateProgram from "@/pages/AffiliateProgram.vue";
import NewslettersAdmin from "@/pages/NewslettersAdmin.vue";
import Welcome from "@/pages/Welcome.vue";
import Studio from "@/pages/Studio.vue";
import { leaveAppForWebsite } from "@/utils/auth";
import i18n from "@/i18n";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      const redirectValue = Array.isArray(to.query?.redirect)
        ? to.query.redirect[0]
        : to.query?.redirect;
      const hasEmailEntryRedirect =
        typeof redirectValue === "string" && redirectValue.startsWith("/");
      if (!hasEmailEntryRedirect) {
        leaveAppForWebsite({ locale: i18n.locale });
        next(false);
        return;
      }
      next();
    },
  },
  {
    path: "/update-password",
    name: "update-password",
    component: UpdatePassword,
    meta: { requiresAuth: true }
  },
  {
    path: "/onboarding",
    name: "onboarding",
    redirect: "/create-clips",
  },
  {
    path: "/public/results/:jobId",
    name: "public-results",
    component: EmptyLayout,
    meta: { requiresAuth: true, requiresAdmin: true, requiresTwitchUser: true },
    children: [
      {
        path: "",
        name: "public-results-child",
        component: PublicResults,
      },
    ],
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/create-clips",
    meta: { requiresAuth: true },
    children: [
      {
        path: "stats",
        redirect: "/user-profile",
      },
      {
        path: "user-profile",
        name: "user-profile",
        component: UserProfileTwitch,
      },
      {
        path: "affiliate-program",
        name: "affiliate-program",
        component: AffiliateProgram,
      },
      {
        path: "billing",
        name: "billing",
        component: Billing,
      },
      {
        path: "billing/success",
        name: "billing-success",
        component: BillingSuccess,
      },
      {
        path: "create-clips",
        name: "make clips",
        component: MakeClips,
      },
      {
        path: "create-clips/:jobId/editor/:clipId",
        name: "make clips editor",
        component: MakeClips,
      },
      {
        path: "create-clips/:jobId",
        name: "make clips job",
        component: MakeClips,
      },
      {
        path: "agenda",
        name: "agenda",
        component: Agenda,
        meta: { requiresAuth: true },
      },
      {
        path: "analisis",
        name: "analisis",
        component: Analysis,
        meta: { requiresAuth: true },
      },
      {
        path: "welcome",
        name: "welcome",
        component: Welcome,
        meta: { requiresAuth: true },
      },
      {
        path: "studio",
        name: "studio",
        component: Studio,
        meta: { requiresAuth: true },
      },
      {
        path: "users",
        name: "users-list",
        component: UsersList,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "dashboard",
        redirect: "/create-clips",
      },
      {
        path: "twitch-postadmin",
        name: "twitch-postadmin",
        component: TwitchPostadmin,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "results",
        name: "results",
        component: Results,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "clipr-purchases",
        name: "clipr-purchases",
        component: CliprPurchases,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "subscription-plans-admin",
        name: "subscription-plans-admin",
        component: SubscriptionPlansAdmin,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: "newsletters",
        name: "newsletters-admin",
        component: NewslettersAdmin,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
